export default __webpack_public_path__ + "static/media/convert-ecredit-to-epoint-step3.951c93dd.png";